const progressUploadValueSelector = ({ adminState: { adminProgressUploadState } }) => adminProgressUploadState.progressValue
const uploadSizeValueSelector = ({ adminState: { adminProgressUploadState } }) => adminProgressUploadState.uploadSizeValue

export {
    progressUploadValueSelector,
    uploadSizeValueSelector
}
